import { Capacitor } from '@capacitor/core';
import type { RegisterDeviceRequest } from 'generated/openapi';

import { getEnvVar } from '@/shared/utils/envVarConfig';

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export type Platform = RegisterDeviceRequest['platform'];

export const getPlatform = (): Platform => {
  const capacitorPlatform = Capacitor.getPlatform();

  switch (capacitorPlatform) {
    case 'android':
      return 'ANDROID';
    case 'ios':
      return 'IOS';
    case 'web':
      return 'WEB';
    default:
      return 'WEB';
  }
};

export function getOAuthRedirectUrls() {
  // Use dynamic origin for non-production web builds (local dev, Cloudflare previews)
  // Use VITE_APP_URL for production builds and native apps
  const isNonProdWeb =
    (import.meta.env.DEV || import.meta.env.MODE !== 'production') &&
    !isNativePlatform();
  const origin = isNonProdWeb
    ? window.location.origin
    : getEnvVar('VITE_APP_URL');
  const signIn = getEnvVar('VITE_COGNITO_REDIRECT_SIGNIN');
  const signOut = getEnvVar('VITE_COGNITO_REDIRECT_SIGNOUT');

  if (getPlatform() === 'IOS' || getPlatform() === 'ANDROID') {
    // Use triple slash (duos:///path) so URL parser treats /oauth/callback as pathname.
    // With double slash (duos://oauth/callback), 'oauth' becomes the host and '/callback' the path.
    return {
      signIn: `duos://${signIn}`,
      signOut: `${origin}${signOut}`,
    };
  }
  return {
    signIn: `${origin}${signIn}`,
    signOut: `${origin}${signOut}`,
  };
}
